import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {ConditionCardScratchpadState} from '../../scratchpad/conditionCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import getSignalsMetadata from '../../utils/conditions/getSignalsMetadata';

const searchSignalToolSchema = z.object({
  conditionField: z
    .string()
    .describe(
      '1-3 word signal search term (from placement data, DSP data, user data, or previously selected products/locations/content) by which an output will be selected',
    ),
});

export default function searchSignalTool(store: CLStore) {
  async function execute({
    input: {conditionField},
    toolUtils: {agentScratchpad},
  }: ToolExecuteParams<
    typeof searchSignalToolSchema,
    ConditionCardScratchpadState
  >): Promise<ToolResult> {
    const {campaign, versionId} = store.getState().campaignPage.campaignTree;

    if (!campaign) {
      return toolResult('Campaign is required to get condition signals');
    }

    if (!versionId) {
      return toolResult('Version ID is required to get condition signals');
    }

    const validatedScratchpad = validateAgentScratchpad<ConditionCardScratchpadState>(
      agentScratchpad,
      NodeType.CONDITION,
    );

    const signalsMetadata = await getSignalsMetadata(conditionField, campaign.id, versionId);

    if (signalsMetadata.length === 0) return toolResult('No signals found');

    validatedScratchpad.card.availableSignals = signalsMetadata;

    return toolResult(`Signals found: ${JSON.stringify(signalsMetadata)}`);
  }

  return tool({
    name: V2CardAgentToolName.SearchSignal,
    displayName: 'Searching signal',
    description: 'Search for a signal',
    execute,
    inputSchema: searchSignalToolSchema,
  });
}
